import { BdsLoadingSpinner, BdsPaper } from 'blip-ds/dist/blip-ds-react/components';
import { Grid } from 'components';
import { ChipTag } from 'components/ChipTag';
import { MetricsContent } from 'components/MetricsContent';
import { MetricsTitle } from 'components/MetricsTitle';
import { useTranslation } from 'react-i18next';
import { MetricsLoadingProps } from 'typings';

type TicketsInAttendanceProps = {
    ticketsCount?: number;
    averageFirstResponseTime?: string;
    maxFirstResponseTime?: string;
    averageResponseTime?: string;
    averageAttendanceTime?: string;
    loading: MetricsLoadingProps;
    showAverages: boolean;
};

export function TicketsInAttendance(ticketsInAttendance: TicketsInAttendanceProps) {
    const { t } = useTranslation();
    const showLoading = ticketsInAttendance.loading.isTicketsLoading;
    const percentage = ticketsInAttendance.loading.ticketsPercentageLoaded;

    return (
        <BdsPaper width="70%" className="metricsContainer" elevation="none">
            <Grid justifyContent="space-between" alignItems="center" margin="x-2">
                <MetricsTitle title={t('go-personal-tickets-attendance-title')} />
                <ChipTag
                    value={t('go-personal-loading-percentage', { percentage: percentage ?? 0 })}
                    color={percentage === 100 ? 'outline' : 'default'}
                />
            </Grid>
            {showLoading ? (
                <Grid justifyContent="center">
                    <BdsLoadingSpinner />
                </Grid>
            ) : (
                <Grid justifyContent="space-around" flexWrap="wrap" margin="x-2" alignItems="center" gap="2">
                    <MetricsContent
                        tooltipPosition="left-top"
                        tooltipText={t('go-personal-tickets-attendance-tooltip-count')}
                        metricsValue={ticketsInAttendance.ticketsCount}
                    >
                        {t('go-personal-tickets-attendance-count')}
                    </MetricsContent>
                    {ticketsInAttendance.showAverages && (
                        <>
                            <div className="border" />
                            <MetricsContent
                                tooltipPosition="left-top"
                                tooltipText={t('go-personal-tickets-attendance-tooltip-avg-first-response')}
                                metricsValue={ticketsInAttendance.averageFirstResponseTime}
                            >
                                {t('go-personal-tickets-attendance-avg-first-response')}
                            </MetricsContent>
                            <MetricsContent
                                tooltipPosition="left-top"
                                tooltipText={t('go-personal-tickets-attendance-tooltip-max-first-response')}
                                metricsValue={ticketsInAttendance.maxFirstResponseTime}
                            >
                                {t('go-personal-tickets-attendance-max-first-response')}
                            </MetricsContent>
                            <MetricsContent
                                tooltipPosition="left-top"
                                tooltipText={t('go-personal-tickets-attendance-tooltip-avg-response')}
                                metricsValue={ticketsInAttendance.averageResponseTime}
                            >
                                {t('go-personal-tickets-attendance-avg-response')}
                            </MetricsContent>
                            <div className="border" />
                            <MetricsContent
                                tooltipPosition="left-top"
                                tooltipText={t('go-personal-tickets-attendance-tooltip-avg-time')}
                                metricsValue={ticketsInAttendance.averageAttendanceTime}
                            >
                                {t('go-personal-tickets-attendance-avg-time')}
                            </MetricsContent>
                        </>
                    )}
                </Grid>
            )}
        </BdsPaper>
    );
}
